import styles from "./NavigationLinkBox.module.css"

const NavigationLinkBox = ({children}) => {
    return<div className={styles.navigationLinkBoxContainer}>{children}</div>
}

export default NavigationLinkBox;